import { AddressRes, AddressTag } from '@dealstack/shared/lib/generated';

export const formatAddress = (address: AddressRes): string =>
	[address.houseNumber, address.street, address.city, address.postCode, address.country]
		.filter((part) => part?.trim())
		.join(', ');

const TAG_PRECEDENCE: AddressTag[] = [
	AddressTag.PRIMARY_ADDRESS,
	AddressTag.REGISTERED_ADDRESS,
	AddressTag.HEAD_OFFICE,
];

export const TAG_LABELS: Record<AddressTag, { key: string; defaultValue: string }> = {
	[AddressTag.PRIMARY_ADDRESS]: {
		key: 'investors.details.addresses_card.tags.primary_address',
		defaultValue: 'Primary address',
	},
	[AddressTag.REGISTERED_ADDRESS]: {
		key: 'investors.details.addresses_card.tags.registered_address',
		defaultValue: 'Registered address',
	},
	[AddressTag.HEAD_OFFICE]: {
		key: 'investors.details.addresses_card.tags.head_office',
		defaultValue: 'Head office',
	},
};

export const getAddressTag = (address: AddressRes): AddressTag | undefined =>
	TAG_PRECEDENCE.find((tag) => address.tags?.includes(tag));

export const sortAddressesTaggedFirst = (addresses: AddressRes[]): AddressRes[] => {
	const tagged: AddressRes[] = [];
	const untagged: AddressRes[] = [];

	for (const address of addresses) {
		(getAddressTag(address) ? tagged : untagged).push(address);
	}

	return [...tagged, ...untagged];
};
